// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".post-section-6[data-v-5abaed84] {\n  padding: 1.5rem 0;\n}\n.post-section-6 div[data-v-5abaed84] {\n  text-align: center !important;\n}\n@media (max-width: 768px) {\n.post-section-6[data-v-5abaed84] {\n    padding: 1rem 0;\n}\n}", ""]);
// Exports
module.exports = exports;
